import React, { FunctionComponent } from 'react';

import { VirtualBackgroundType } from '@yandex-360/telemost-sdk/device-manager';
import cn from 'classnames';

import { SvgImage } from '../../../../components';
import css from './styles.css';
import { BackgroundOptionItem } from './types';

interface BackgroundOptionProps {
    item: BackgroundOptionItem;
    selected?: boolean;
    onClick?: () => void;
}

export const BackgroundOption: FunctionComponent<BackgroundOptionProps> = ({ item, selected, onClick }) => {
    const { title, type, isNda = false } = item;

    const blurred = type === VirtualBackgroundType.BLURRED;

    const optionClasses = cn(css.option, {
        [css.blurred]: blurred,
        [css.selected]: selected,
    });

    const clickHandler = () => {
        if (!selected) {
            onClick?.();
        }
    };

    return (
        <div className={css.optionWrapper}>
            {isNda && <SvgImage className={css.ndaPin} imageName="nda" />}
            <button type="button" className={optionClasses} onClick={clickHandler}>
                <span className={css.title}>{title()}</span>
            </button>
        </div>
    );
};
